/**
 * Valeurs possibles des choix du brief. Les libellés affichés vivent dans
 * le contenu (`content/`), le domaine ne manipule que des identifiants stables
 * qui seront aussi ceux de l'API.
 */
export const PROJECT_TYPES = [
  'showcase',
  'ecommerce',
  'mobile-app',
  'immersive',
  'redesign',
] as const;
export type ProjectType = (typeof PROJECT_TYPES)[number];

export const BRAND_STATUSES = ['existing', 'in-progress', 'none'] as const;
export type BrandStatus = (typeof BRAND_STATUSES)[number];

export const BUDGET_RANGES = ['range-1', 'range-2', 'range-3', 'undecided'] as const;
export type BudgetRange = (typeof BUDGET_RANGES)[number];

export const TIMELINES = ['under-1-month', '1-3-months', '3-6-months', 'flexible'] as const;
export type Timeline = (typeof TIMELINES)[number];
